// 체크박스 선택 시 이벤트 실행하는 함수

/** 외부 필터 등으로 숨겨진 행이 선택된 경우 해제 (헤더 전체선택 보정) */
export function pruneSelectionForNonDisplayedRows(gridApi) {
  if (!gridApi?.isExternalFilterPresent?.()) return;

  gridApi.forEachNode((node) => {
    if (node.rowPinned === 'bottom' || node.rowPinned === 'top') return;
    if (node.isSelected?.() && node.displayed === false) {
      node.setSelected(false, false, 'filterSync');
    }
  });
}

export const GridCheckBoxFunction =
  ({
    params,
    rowIndex,
    rowData,
    gridRef,
    selectedRowNosRef,
    lastCheckedIndexRef,
    handleRowSelection,
    /** 퀵필터 등으로 rowIndex와 rowData 배열 순서가 어긋날 때 node.data 우선 (표준모델 모달 등) */
    preferNodeRowData,
  }) =>
  (e) => {
    const gridApi = gridRef?.current?.api;
    if (!gridApi) {
      return;
    }
    const rowNo = params.data?.no;

    const isChecked = e.target.checked;
    const isShift = e.nativeEvent.shiftKey;

    if (isShift && lastCheckedIndexRef.current !== null) {
      const start = Math.min(lastCheckedIndexRef.current, rowIndex);
      const end = Math.max(lastCheckedIndexRef.current, rowIndex);

      for (let i = start; i <= end; i++) {
        const node = gridApi.getDisplayedRowAtIndex(i);
        const currentNo = node?.data?.no;
        if (currentNo != null) {
          isChecked
            ? selectedRowNosRef.current.add(currentNo)
            : selectedRowNosRef.current.delete(currentNo);
        }
      }
    } else {
      isChecked
        ? selectedRowNosRef.current.add(rowNo)
        : selectedRowNosRef.current.delete(rowNo);
    }

    // multiple: 변경 노드만 묶어 setNodesSelected (v31+ 권장). single: nodes.length>1이면 setNodesSelected가 전부 무시되므로 노드별 setSelected 유지
    const rowSelection =
      typeof gridApi.getGridOption === 'function'
        ? gridApi.getGridOption('rowSelection')
        : undefined;
    const isMultiSelect = rowSelection === 'multiple';

    const applySelectionPerNode = () => {
      gridApi.forEachNode((node) => {
        if (node.rowPinned === 'bottom' || node.rowPinned === 'top') {
          return;
        }
        const currentNo = preferNodeRowData ? node?.data?.no : node.data?.no;
        const shouldSelect = preferNodeRowData
          ? currentNo != null && selectedRowNosRef.current.has(currentNo)
          : selectedRowNosRef.current.has(currentNo);
        if (node.isSelected() !== shouldSelect) {
          node.setSelected(shouldSelect, false, 'checkboxSync');
        }
      });
    };

    if (!isMultiSelect) {
      applySelectionPerNode();
    } else {
      const toSelect = [];
      const toDeselect = [];
      gridApi.forEachNode((node) => {
        if (node.rowPinned === 'bottom' || node.rowPinned === 'top') {
          return;
        }
        const currentNo = preferNodeRowData ? node?.data?.no : node.data?.no;
        const shouldSelect = preferNodeRowData
          ? currentNo != null && selectedRowNosRef.current.has(currentNo)
          : selectedRowNosRef.current.has(currentNo);
        if (node.isSelected() === shouldSelect) {
          return;
        }
        if (shouldSelect) {
          toSelect.push(node);
        } else {
          toDeselect.push(node);
        }
      });
      if (toDeselect.length > 0) {
        gridApi.setNodesSelected({
          nodes: toDeselect,
          newValue: false,
          source: 'checkboxSync',
        });
      }
      if (toSelect.length > 0) {
        gridApi.setNodesSelected({
          nodes: toSelect,
          newValue: true,
          source: 'checkboxSync',
        });
      }
    }

    const clickedRowData = preferNodeRowData
      ? params.node?.data ?? rowData[rowIndex]
      : rowData[rowIndex];

    if (clickedRowData) {
      const copied = JSON.parse(JSON.stringify(clickedRowData));
      handleRowSelection(copied, rowIndex);
    } else if (preferNodeRowData && handleRowSelection) {
      handleRowSelection(null, rowIndex);
    }

    lastCheckedIndexRef.current = rowIndex;
  };
